var map = {
	"./analytics-white.svg": 12022,
	"./arrow-right-plain.svg": 54907,
	"./arrowRight.svg": 71325,
	"./arrowRightBlack.svg": 25298,
	"./boat-white.svg": 7428,
	"./bulb.svg": 11807,
	"./calculation-white.svg": 2045,
	"./chain-blue.svg": 81766,
	"./charging-white.svg": 859,
	"./chart-histogram.svg": 38331,
	"./chart-tree-blue.svg": 48308,
	"./chart-tree.svg": 80335,
	"./chevron-up.svg": 95195,
	"./clock-white.svg": 58280,
	"./clock.svg": 16968,
	"./close.svg": 16334,
	"./comment.svg": 92313,
	"./crown-white.svg": 61635,
	"./crown.svg": 77571,
	"./database-white.svg": 45181,
	"./diamond.svg": 65698,
	"./document-blue.svg": 75966,
	"./gear-blue.svg": 59880,
	"./head-thinking.svg": 85229,
	"./headphones-blue.svg": 79020,
	"./headset.svg": 36048,
	"./magnifying-glass-blue.svg": 56599,
	"./menu.svg": 49059,
	"./microscope-white.svg": 9358,
	"./minus-white.svg": 3578,
	"./network-white.svg": 12052,
	"./networking-white.svg": 84996,
	"./paint-brush.svg": 85697,
	"./pen-blue.svg": 65448,
	"./piggy-bank.svg": 21789,
	"./plus-gray.svg": 45462,
	"./pointer-blue.svg": 90634,
	"./puzzle-blue.svg": 50743,
	"./question-blue.svg": 44027,
	"./reload-white.svg": 79693,
	"./shield-white.svg": 51837,
	"./smile-white.svg": 29930,
	"./storage-blue.svg": 81286,
	"./thumb.svg": 21986,
	"./wrench.svg": 91909
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 84990;